<template>
  <mini-card :value="'$'+totalPaidPayouts" subtitle="Paid" :previousValue="'$'+totalPaidPayoutsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-sack-dollar text-primary"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last payment: &nbsp;<i>{{lastPayment}}</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
import utils from '../../utils'
export default {
  name: 'Payouts-Paid-MiniCard',
  components: {
    MiniCard
  },
  methods: {},
  computed: {
    totalPaidPayouts () {
      return this.$store.getters.totalPayouts({status: Payout._status.PAID})
    },
    totalPaidPayoutsPrevious () {
      return this.$store.getters.totalPayoutsPrevious({status: Payout._status.PAID})
    },
    lastPayment () {
      // we find out the most recent submission
      const payouts = this.$store.getters.payouts
      let date = new Date(0)
      if (payouts && payouts.length > 0) {
        payouts.forEach(payout => {
          // console.log('payout = ', payout)
          if (payout.status == this.$store.getters.Payout._status.PAID.value
              && !payout.archived
              && payout.datePaid && payout.datePaid.getTime() > date.getTime()) {
                date = payout.datePaid
          }
        })
        if (date.getTime() > 0) {
          return utils.dateToString(date)
        }
      }
      return '-'
    }
  }
}
</script>

<style>

</style>